import { AuthIntent } from '@/features/auth/internal/types/social-auth';

export const AUTH_INTENT_COOKIE = 'auth_intent';
export const AUTH_INTENT_MAX_AGE = 300; // 5 minutes

export const DESKTOP_OAUTH_SESSION_COOKIE = 'desktop_oauth_session';

export const NEWSLETTER_CONSENT_COOKIE = 'newsletter_consent';

export const setAuthIntentCookie = (intent: AuthIntent): void => {
  document.cookie = `${AUTH_INTENT_COOKIE}=${intent}; path=/; max-age=${AUTH_INTENT_MAX_AGE}; SameSite=Lax`;
};

export const setNewsletterConsentCookie = (subscribed: boolean): void => {
  const value = subscribed ? '1' : '0';
  document.cookie = `${NEWSLETTER_CONSENT_COOKIE}=${value}; path=/; max-age=${AUTH_INTENT_MAX_AGE}; SameSite=Lax`;
};
